import React from "react";

import './TimelineBodySection.css';
const TimelineBodySection = ({ title, img}) => {
    return (
        <>
            <div className="timeline-content" >
                {/* Title of the box, on the left side */}
                <div className="timeline-title">
                    <h4>{title}</h4>
                </div>

                {/* Body of the box, on the right side */}
                <div className="timeline-body">
                    <img src={img} alt="" srcset="" />
                </div>

            </div>
        
        </>
    )
}

export default TimelineBodySection;
